import React, { createContext, ReactNode, useEffect, useState } from "react";
import { getConstants } from "../api/mainAPI";
import { Constants } from "../types/api/constants";
import { AuthProfile } from "../types/api/main";

interface Props {
    children: ReactNode;
}

export interface MainContextState {
    constants: Constants;
    user: AuthProfile;
    setUser: (value: any) => void;
}

const MainContext = createContext<Partial<MainContextState>>({});

const MainProvider = ({ children }: Props) => {
    const [constants, setConstants] = useState<Constants>();
    const [user, setUser] = useState<any>();

    useEffect(() => {
        getConstants(({ data }) => {
            setConstants(data[1]);
        });
    }, []);
    return <MainContext.Provider value={{ constants, user, setUser }}>{children}</MainContext.Provider>;
};

export { MainProvider, MainContext };
